import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=c492f264&scoped=true"
import script from "./TextPage.vue?vue&type=script&lang=js"
export * from "./TextPage.vue?vue&type=script&lang=js"
import style0 from "./TextPage.vue?vue&type=style&index=0&id=c492f264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c492f264",
  null
  
)

export default component.exports